<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="원장님 스케줄" write-toggler @writeClick="popupOpen('', '')">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left"
                        @click="prevMonth"></vs-button>
                    <span class="ml-5 mr-5">{{ this.start_date.substring(0, 4) + '-' + this.start_date.substring(4, 6) + '-' +
                        this.start_date.substring(6, 8) }} ~
                        {{ this.end_date.substring(0, 4) + '-' + this.end_date.substring(4, 6) + '-' + this.end_date.substring(6, 8)
                        }}</span>
                  <date-picker
                      id="datepicker-component"
                      v-model="now_date"
                      @change="updateDate"
                      type="week"
                      :lang="{formatLocale: {firstDayOfWeek: 1}}"
                      value-type="format"
                      format="YYYYMMDD"
                  >
                  </date-picker>
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right"
                        @click="nextMonth"></vs-button>
                </div>
            </div>
            <vs-button type="line" v-bind:class="activeMenu('')" v-on:click="tabClick('')">전체</vs-button>
            <vs-button type="line" v-for="(item, index) in tab_menu" :key="index" v-bind:class="activeMenu(item.MEDICAL_CD)"
                v-on:click="tabClick(item.MEDICAL_CD)">{{ item.MEDICAL_NM }}</vs-button>
            <br /><br />
            <span>* 해당 날짜에 시간 셀을 클릭하시면 환자를 등록할 수 있습니다.</span>
            <!-- <div>
            <div>
                <div style="display: flex; justify-content: space-between; width: 60%;">
                    <span v-for="(item, index) in filteredDates" :key="index">
                    {{ dayReturn(item) }}
                    </span>
                </div>
                    <div style="display: flex; justify-content: space-between; width: 60%;">
                        <div v-for="(item, index) in visibleSchedules" :key="index">
                            <div
                                v-for="(schedule_item, schedule_index) in item.YMD.split(',')"
                                :key="schedule_index"
                            >
                                <div v-for="(item_data, item_index) in gridReturnCurrentDate(index, schedule_index)" :key="item_index">
                                <span>{{ item_data.reservation_time.substring(0, 2) }}:{{ item_data.reservation_time.substring(2, 4) }}</span>
                                <span>[{{ item_data.medical_nm }}]</span>
                                <span>
                                    <template v-if="item_data.dc == 'Y'">
                                    <span style="text-decoration:line-through">{{ item_data.medical_room_number_nm }} {{ item_data.patient_username }}</span>
                                    </template>
                                    <template v-else>{{ item_data.medical_room_number_nm }} {{ item_data.patient_username }}</template>
                                </span>
                                <span>
                                    <template v-if="item_data.dc == 'Y'">
                                    <span style="text-decoration: line-through;">{{ item_data.gubun_txt }}</span>
                                    </template>
                                    <template v-else><span>{{ item_data.gubun_txt }}</span></template>
                                </span>
                                <span>
                                    <template v-if="item_data.dc == 'Y'">
                                    <span>{{ item_data.dc_memo }} {{ item_data.memo_etc }}</span>
                                    </template>
                                    <template v-else>{{ item_data.managerNmList }} / {{ item_data.detailNmList }} / {{ item_data.memo }} {{ item_data.memo_etc }}</template>
                                </span>
                                <span>{{ item_data.medical_member_username }} / {{ item_data.west_medical_username }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <span id="statuscnt6Id">재원 : {{ status_cnt_6 }}</span>
            <div class="flex justify-end flex-wrap">
                <div v-for="(item, index) in doctor_cnt" :key="index" class="flex justify-end flex-wrap">
                    <span class="mr-1 mb-3">{{ item.MEDICAL_NM }}:({{ item.CNT }}) </span>
                </div>
            </div>
            <div class="flex justify-end flex-wrap mb-3">
                <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="popupOpen('', '')" />
                <!-- <a :href="'/api/doctor/excel/' + now_date + '?medical_cd=' + medical_cd" download="download"><vs-button size="small">엑셀다운로드</vs-button></a> -->
                <vx-tooltip text="엑셀 다운로드" position="top" class="ml-3">
                    <a :href="'/api/doctor/excel/' + now_date + '?medical_cd=' + medical_cd"
                        download="download"><vs-button radius color="primary" icon-pack="feather"
                            icon="icon-download" /></a>
                </vx-tooltip>
            </div>
            <div class="tb_wrap">
                <div class="tb_box" id="calendarDiv" style="width:100%;overflow-x:auto; height:900;">
                    <table id="schedule" style="max-width:1200px; max-height:500px;" class="border-collapse calendar">
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    style="width:100px !important;">시간 / 일</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    :style="item.substring(6, 8) == now_day ? 'background-color:#439798 !important; color:#fff;z-index:999;' : 'z-index:999;'"
                                    v-for="(item, index) in date_list" :key="index" :id="item">
                                    <div style="padding-bottom:5px;">
                                        <b style="font-size:12px;">{{ dayReturn(item) }}</b>
                                    </div>
                                    <div>
                                        <!-- {{JSON.parse(cure_count[index].JSON_DATA)}} -->
                                        <!-- <span v-for="(item2, index2) in JSON.parse(cure_count[index].JSON_DATA)"
                                            :key="index2" style="margin-top:10px;">
                                             <template
                                                v-if="JSON.parse(cure_count[index].JSON_DATA)[index2 + 1] == undefined"> {{
                                                    item2.MEDICAL_NM }}({{ item2.CNT }}) </template>
                                             <template v-else> {{ item2.MEDICAL_NM }}({{ item2.CNT }}) </template>
                                            <template> {{ item2.MEDICAL_NM }}({{ item2.CNT }}) </template>
                                        </span> -->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in cure_data" :key="index">
                                <th class="border border-solid d-theme-border-grey-light text-center table_header b-table-sticky-column timeHeader"
                                    style="" :id="item.CODE_TIME.substring(0, 2)">
                                    <span> {{ item.CODE_TIME.substring(0, 2) }}</span>
                                </th>
                                <td class="border border-solid d-theme-border-grey-light"
                                    style="min-width:600px;height:100px;vertical-align:top;padding:0px;"
                                    v-for="(schedule_item, schedule_index) in item.YMD.split(',')" :key="schedule_index">
                                    <table class="contentTable" width="100%" cellspacing="0">
                                        <colgroup>
                                            <col width="50" />
                                            <col width="50" />
                                            <col width="20" />
                                            <col width="100" />
                                            <col width="220" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="230" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th class="text-center headerBtn" colspan="8">
                                                    <vs-row vs-type="flex" vs-justify="center">
                                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center"
                                                            vs-w="12">
                                                            <a href="javascript:void(0)"
                                                                @click="popupOpen(item.YMD.split(',')[schedule_index], item.CODE_TIME)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                                                                    style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a>

                                                            <a href="javascript:void(0)"
                                                                @click="clipCopyConfirm(item.YMD.split(',')[schedule_index], item.CODE_TIME)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-copy null"
                                                                    style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a>
                                                        </vs-col>
                                                    </vs-row>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item_data, item_index) in gridReturn(index, schedule_index)"
                                                :key="item_index" :class="item_data.btn_color">
                                                <td>
                                                    <input type="checkbox" v-model="copyChecked"
                                                        :value="item_data.schedule_seq" />
                                                </td>
                                                <td>{{ item_data.reservation_time.substring(0, 2) }}:{{
                                                    item_data.reservation_time.substring(2, 4) }}</td>
                                                <td>[{{ item_data.medical_nm.substring(0, 1) }}]</td>
                                                <td>
                                                    <a :href="'/patientSchedule/scheduleCalendar/' + item_data.patient_uid">
                                                        <template v-if="item_data.dc == 'Y'">
                                                            <span style="text-decoration:line-through">{{
                                                                item_data.medical_room_number_nm }} {{
                                                                item_data.patient_username }}</span>
                                                        </template>
                                                        <template v-else>{{ item_data.medical_room_number_nm }} {{
                                                            item_data.patient_username }}</template>
                                                    </a>
                                                </td>
                                                <template v-if="item_data.dc == 'Y'">
                                                    <td style="text-decoration: line-through;">{{ item_data.gubun_txt }}
                                                    </td>
                                                </template>
                                                <template v-else>
                                                    <td>{{ item_data.gubun_txt }}</td>
                                                </template>
                                                <td>
                                                    <template v-if="item_data.dc == 'Y'">
                                                        <span>{{ item_data.dc_memo }} {{ item_data.memo_etc }}</span>
                                                    </template>
                                                    <template v-else>{{ item_data.managerNmList }} / {{
                                                        item_data.detailNmList }} / {{ item_data.memo }} {{
                                                        item_data.memo_etc }}</template>
                                                </td>
                                                <td>{{ item_data.medical_member_username.substring(0, 1) }} / {{
                                                    item_data.west_medical_username.substring(0, 1) }}</td>
                                                <td>
                                                    <template
                                                        v-if="item_data.insert_gubun != '99' && item_data.insert_gubun != '97'">
                                                        <a href="#"
                                                            @click="memberView(item_data.patient_uid, item_data.insert_gubun)">
                                                            <i class="vs-icon notranslate icon-scale  feather icon-search null"
                                                                style="order: 0; margin-right: 0px; margin-left: 0px; color:#31C872;"></i>
                                                        </a>
                                                    </template>
                                                    &nbsp;
                                                    <a href="#" @click="popupmodify(item_data)">
                                                        <i class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                                                            style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <a href="javascript:void(0)" @click="calendarTdDelete(item_data)">
                                                        <i class="vs-icon notranslate icon-scale  feather icon-x null"
                                                            style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <template v-if="item_data.insert_gubun == '97'">
                                                        <a href="javascript:void(0)"
                                                            @click="deleteAllConfirm(item_data.schedule_seq)">
                                                            <i class="vs-icon notranslate icon-scale  feather icon-trash null"
                                                                style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                                        </a>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </vx-card>
        <vs-popup title="스케줄 등록" :active.sync="popupActive">
            <form @submit.prevent>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <vs-select class="w-auto" autocomplete v-model="select_medical_cd" label="원장님" placeholder="스케줄 옵션">
                            <vs-select-item v-for="(item, index) in tab_menu" :key="index" :value="item.MEDICAL_CD"
                                :text="item.MEDICAL_NM" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 ">
                        <label for="" class="vs-select--label">날짜</label>
                        <datepicker name="uniquename" v-model="select_date" :locale="'ko'" placeholder="날짜선택"
                            :format="customFormatter" id="select_date"></datepicker>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <label for="" class="vs-select--label">시간(hhmm)-ex.0930</label>
                        <input type="text" class="w-full vs-inputx vs-input--input normal hasValue" id="select_time"
                            name="select_time" label="시간을 입력해주세요." placeholder="시간을 입력해주세요." maxlength="4"
                            v-model="select_time" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 ">
                        <vs-select class="w-auto" v-model="select_gubun" autocomplete label="등록 구분" placeholder="등록 구분"
                            @change="[
                                gubunChange,
                            ]">
                            <vs-select-item :value="''" :text="'-선택-'" />
                            <vs-select-item v-for="(item, index) in gubun_list" :key="index" :value="item.VALUE"
                                :text="item.TEXT" />
                        </vs-select>
                    </div>
                </div>
                <vs-divider color="danger">DC</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 justify-between">
                        <span>
                            <vs-checkbox v-model="dc" style="width: 30%;">
                                DC
                            </vs-checkbox>
                        </span>
                    </div>
                    <div class="vx-col w-full lg:w-1/2 justify-between">
                        <span>
                            <vs-checkbox v-model="awaitTimeChk" @change="setAwaitTime" style="width: 30%;">
                                대기
                            </vs-checkbox>
                        </span>
                    </div>
                    <div class="vx-col w-full lg:w-1/1 justify-between">
                        <template v-if="dc == true">
                            <vs-input v-model="dc_memo" placeholder="취소사유" class="mt-1 w-full" />
                        </template>
                        <template >
                            <vs-input v-model="awaitTime" placeholder="시간" class="mt-1 w-full" v-show="this.userUid == '04059'"/>
                        </template>
                    </div>
                </div>
                <div class="mb-3"
                    v-show="select_gubun == '1' || select_gubun == '2' || select_gubun == '3' || select_gubun == '4' || select_gubun == '5' || select_gubun == '6' || select_gubun == '98'">
                    <vs-divider color="danger">환자</vs-divider>
                    <div class="vx-col w-full lg:w-1/1">
                        <v-select :maxHeight="'50px'" ref="searchInput" v-model="select_user" :closeOnSelect="true" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" @open="resetOption()"/>
                        <!-- <vs-input class="w-1/1" icon="search" placeholder="환자 이름 or 전화번호 or 차트번호 입력 후 엔터(Enter)" v-model="search" @keyup.enter="searchPatient()" /> -->
                    </div>
                </div>
                <div class="mb-3">
                    <!-- <div class="mb-3" v-else-if="select_gubun == '99'"> -->
                    <vs-divider color="danger">메모</vs-divider>
                    <vs-input class="w-full" name="memo" v-model="memo" label="" placeholder="메모 하실 내용을 입력하여 주십시오." />
                </div>

                <div class="mb-3">
                    <vs-divider color="danger">비고</vs-divider>
                    <vs-input class="w-full" name="memo_etc" v-model="memo_etc" label="" placeholder="비고" />
                </div>
                <div class="mb-3 vx-row" v-if="select_gubun == '97' && (schedule_seq == -1 || schedule_seq == '')">
                    <vs-divider color="danger">반복설정 여부</vs-divider>
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-checkbox :vs-value="'true'" v-model="autoCheck" @change="autoEvent">반복설정 여부</vs-checkbox>
                    </div>
                    <template v-if="autoCheck == 'true'">
                        <div class="vx-col w-full lg:w-1/2 mb-base">
                            <div class="vx-col w-full lg:w-1/1 ">
                                <vs-select autocomplete class="w-auto" name="schedule_gubun_type"
                                    v-model="schedule_gubun_type" label="주기옵션" placeholder="주기선택"
                                    @change="schedule_gubunChange">
                                    <vs-select-item :value="1" :text="'일'" />
                                    <vs-select-item :value="2" :text="'주'" />
                                    <vs-select-item :value="3" :text="'개월'" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-col w-full lg:w-1/2 mb-base">
                            <div class="vx-col w-full lg:w-1/1 ">
                                <vs-input class="w-full" name="memo" v-model="schedule_gubun_number" label="주기"
                                    placeholder="" />
                            </div>
                        </div>

                        <div class="vx-col w-full lg:w-1/1 mb-base" v-if="schedule_gubun_type == 2">
                            <ul class="centerx">
                                <li>
                                    <vs-checkbox :vs-value="'1'" v-model="schedule_week">월</vs-checkbox>
                                </li>
                                <li>
                                    <vs-checkbox :vs-value="'2'" v-model="schedule_week">화</vs-checkbox>
                                </li>
                                <li>
                                    <vs-checkbox :vs-value="'4'" v-model="schedule_week">수</vs-checkbox>
                                </li>
                                <li>
                                    <vs-checkbox :vs-value="'8'" v-model="schedule_week">목</vs-checkbox>
                                </li>
                                <li>
                                    <vs-checkbox :vs-value="'16'" v-model="schedule_week">금</vs-checkbox>
                                </li>
                                <li>
                                    <vs-checkbox :vs-value="'32'" v-model="schedule_week">토</vs-checkbox>
                                </li>
                                <li>
                                    <vs-checkbox :vs-value="'64'" v-model="schedule_week">일</vs-checkbox>
                                </li>
                            </ul>
                        </div>
                        <div class="vx-col w-full lg:w-1/1 mb-base" v-if="schedule_gubun_type == 3">
                            <div class="vx-col w-full lg:w-1/1 ">
                                <vs-select autocomplete class="w-auto" name="schedule_gubun_day" label="매월(일)주기"
                                    v-model="schedule_gubun_days" placeholder="매월(일)주기">
                                    <vs-select-item v-for="index in 31" :key="index" :value="index" :text="index + '일'" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-col w-full lg:w-1/1 mb-base">
                            <div class="vx-col w-full lg:w-1/1 ">
                                <vs-radio vs-value="N" v-model="schdule_endYN" @input="schedule_end = ''">없음</vs-radio>
                            </div>
                            <div class="vx-col w-full lg:w-1/1 ">
                                <ul class="centerx">
                                    <li>
                                        <vs-radio vs-value="Y" v-model="schdule_endYN">종료날짜</vs-radio>
                                    </li>
                                    <li style="padding-left:20px;">
                                        <datepicker name="patientBirthday" :disabled="schdule_endYN == 'N'"
                                            v-model="schedule_end" :locale="'ko'" placeholder="날짜선택"
                                            :format="customFormatter" id="select_date"></datepicker>

                                        <!-- <date-picker name="patientBirthday" :locale="'ko'" v-model="schedule_end" valueType="format" class="vs-inputx normal w-full"></date-picker> -->
                                    </li>
                                </ul>
                            </div>
                            <div class="vx-col w-full lg:w-1/1 "></div>
                        </div>
                    </template>
                </div>
                <div class="vx-row" style="margin-top:100px;">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="calendarSave">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="popupClose">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>

        <vs-popup title="챠트보기" :active.sync="popupActive2">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <vx-card class="p-2">
                        <div class="text-center">
                            <p class="text-grey">#{{ chart_no }}</p>
                            <h4>{{ patientUsername }}({{ status_name }})</h4>
                            <p class="text-grey">{{ patientAge }}, {{ patientGender }}</p>
                            <p class="text-grey">{{ patient_phone }}</p>
                        </div>
                        <vs-divider></vs-divider>

                        <div class="flex justify-between text-center">
                            <span>
                                <p class="font-semibold">{{ medicalRoomNm }}({{ medicalRoomNumberNm }})</p>
                                <small class="text-grey">병동(호실)</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ medicalName }}</p>
                                <small class="text-grey">본 병원</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ sickNess }}</p>
                                <small class="text-grey">병명</small>
                            </span>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="my-6">
                            <h5 class="mb-2">치료플랜</h5>
                            <p class="plan_text">
                                <template v-if="plan == null || plan == 0">작성한 치료플랜 없음</template>
                                <template v-else>{{ plan }}</template>
                            </p>
                        </div>
                        <vs-divider></vs-divider>
                        <table style="width:100%;" class="border-collapse calendar">
                            <colgroup>
                                <col width="40%" />
                                <col width="60%" />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        최초입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_init_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        퇴원예정일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ out_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        왼퇴여부</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ complate_yn }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        식이</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ meal_name }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        보호자</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ protector_phone }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        주치의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ medical_nm }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        협진의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ west_medical_nm }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import vSelect from 'vue-select';
import moment from 'moment';
import store from "@/store/store";
import Datepicker from 'vuejs-datepicker';
import DatePicker from 'vue2-datepicker';
import '../../assets/scss/vuexy/extraComponents/_datePicker.scss'
export default {
    components: {
      Datepicker,
      DatePicker,
      'v-select': vSelect,
    },
    data() {
        return {
            selectedDate: moment().format("YYYYMMDD"), // 선택된 날짜를 저장함
            status_cnt_6: 0, // 재원값 데이터 추가
            date: dateClass.dateYYYYMMDD(),
            now_date: '',
            prev_date: '',
            next_date: '',
            medical_cd: '',
            popupActive: false,
            time_index: -1,
            tab_menu: [],
            time_data: [],
            cure_data: [],
            cure_count: [],
            date_list: [],
            patient_member_list: [],
            time_list: [],
            select_medical_cd: '',
            select_date: '',
            select_time: '',
            memo: '',
            memo_etc: '',
            select_user: '',
            options: [],
            now_day: '',
            select_gubun: '',
            gubun_list: [
                { VALUE: '1', TEXT: '초진' },
                { VALUE: '2', TEXT: '재진' },
                { VALUE: '3', TEXT: '신입진료' },
                { VALUE: '4', TEXT: '재입진료' },
                { VALUE: '5', TEXT: '입원중진료' },
                { VALUE: '6', TEXT: '퇴원진료' },
                { VALUE: '97', TEXT: '휴진' },
                { VALUE: '98', TEXT: '외래' },
                { VALUE: '99', TEXT: '기타' },
            ],
            copy_schedule_seq: -1,
            copy_select_date: '',
            copy_select_time: '',
            dragBool: false,
            popupActive2: false,
            patientUsername: '',
            patientUid: '',
            patientAge: '',
            patientGender: '',
            medicalRoomNm: '',
            medicalRoomNumberNm: '',
            medicalName: '',
            sickNess: '',
            plan: '',
            chart_no: '',
            status_name: '',
            patient_phone: '',
            in_init_date: '',
            in_date: '',
            out_date: '',
            complate_yn: '',
            meal_name: '',
            medical_nm: '',
            west_medical_nm: '',
            protector_phone: '',
            dc: false,
            dc_memo: '',
            copyChecked: [],
            start_date: '',
            end_date: '',
            schedule_seq: '',
            doctor_cnt: [],
            doctor_cnt_2: [],
            width: window.innerWidth,
            autoCheck: null,
            schdule_endYN: 'N',
            schedule_end: '',
            schedule_week: [],
            schedule_gubun_type: 0,
            schedule_gubun_number: 1,
            schedule_gubun_days: 0,
            selected_schedule_seq: 0,
            selectGubunIndex : 0,
            prevDoctorSchedule: null,
            prevGubunIndex: 0,
            doctorconversationList : {
                '02004' : '6605110', // 김지호 원장님 //
                '02006' : '6605109', // 구자일 원장님 //
                '02007' : '6291857', // 윤성훈 원장님
                '02009' : '6605111', // 전정헌 원장님 //
                '02016' : '6605113', // 한연수 원장님 //
                '02017' : '6605114', // 정윤진 원장님 //
                '02018' : '6605116', // 정인호 원장님 //
                '02019' : '6605115', // 진영문 원장님 //
                '04001' : '6287706', // 이성준 원장님
                '04059' : '6226325', // test1
            },
            awaitTime : '',
            awaitTimeChk : false,
            userUid : '',
            search : ''
        };
    },
    methods: {
      dateClass() {
        return dateClass
      },
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async init(date) {
            this.now_day = dateClass.nowday();
            this.userUid = store.getters.getUID;

            if (date == '') {
                this.now_date = dateClass.dateYYYYMMDD();
            } else {
                this.now_date = date;
            }
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            const { data } = await axiosClass.get('/api/doctor/list/' + this.now_date, {}, true);

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.tab_menu = data.tab_menu;
            this.date_list = data.cure_data[0].YMD.split(',');
            this.cure_data = data.cure_data;
            //console.log(data);
            this.cure_count = data.cure_count;
            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];
            this.doctor_cnt = data.doctor_cnt;


            setTimeout(function () {
                var element = document.getElementById(dateClass.dateYYYYMMDD());
                element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }, 500);
        },
        async getState() { // 재원값 추가

            const { data } = await axiosClass.get('/api/ward/status', {}, true);
            this.status_cnt_6 = data.status_cnt_6;
        },

        async tabClick(medical_cd) {
            this.medical_cd = medical_cd;
            console.log(medical_cd);
            const params = {
                medical_cd: medical_cd,
            };
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            const { data } = await axiosClass.get('/api/doctor/view/' + this.now_date, params, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.date_list = data.cure_data[0].YMD.split(',');
            this.cure_data = data.cure_data;
            this.cure_count = data.cure_count;

            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];
        },
        gubunChange(event) {
            this.selectGubunIndex = 0;
            if (this.select_gubun == '') {
                this.memo = '';
                this.select_user = '';
                this.selectGubunIndex = event.target.indexOf();
            } else if (this.select_gubun == '1' || this.select_gubun == '2') {
                this.memo = '';
                this.selectGubunIndex = event.target.indexOf();
            } else if (this.select_gubun == '99') {
                this.select_user = '';
                this.selectGubunIndex = event.target.indexOf();
            }

            if (this.select_gubun != '97') {
                this.autoCheck = null;
                this.schdule_endYN = 'N';
                this.schedule_end = '';
                this.schedule_week = [];
                this.schedule_gubun_type = 0;
                this.schedule_gubun_number = 1;
                this.schedule_gubun_days = 0;
                this.selectGubunIndex = event.target.indexOf();
            }
        },
        schedule_gubunChange() {
            if (this.schedule_gubun_type != 2) {
                this.schedule_week = [];
            }
            if (this.schedule_gubun_type != 3) {
                this.schedule_gubun_days = 0;
            }
        },

        async memberView(uid, gubun) {
            this.$EventBus.$emit('memberView', uid);
            // if (gubun == '1') {
            //     this.$EventBus.$emit('memberCs', uid);
            // } else {
            //     this.$EventBus.$emit('memberView', uid);
            // }
        },

        async popupmodify(item) {
            console.info('수정 process');
            this.schedule_seq = item.schedule_seq;
            this.select_gubun = item.insert_gubun;
            //console.log("===>" + item.schedule_seq);
            this.popupActive = true;
            const { data } = await axiosClass.get('/api/doctor/schedule/' + item.schedule_seq, {}, true);
            // this.time_list = data.timeList;
            // this.popupActive = true;
            // this.options = [];
            this.select_medical_cd = this.medical_cd;
            this.select_user = data.memberSelect;
            // console.log("===>" + data.memberSelect);
            this.memo_etc = data.selectData.MEMO_ETC;
            this.memo = data.selectData.MEMO;

            if (this.select_gubun == -1) {
                this.select_gubun = '';
            }

            if (data.selectData.PATIENT_UID == null && this.select_gubun != 97) {
                this.select_gubun = 99;

                this.memo = data.selectData.MEMO;
            } else {
                if (data.selectData.INSERT_GUBUN == null) {
                    this.select_gubun = 2;
                } else {
                    this.select_gubun = data.selectData.INSERT_GUBUN;
                    if (this.select_gubun == -1) {
                        this.select_gubun = '';
                    }
                }

                // for (let i = 0; i < data.memberList.length; i++) {
                //     this.options.push({
                //         id: data.memberList[i].PATIENT_UID,
                //         label: data.memberList[i].MEDICAL_ROOM_NM + '-' + data.memberList[i].MEDICAL_ROOM_NUMBER_NM + ':' + data.memberList[i].PATIENT_USERNAME,
                //     });

                // }
                //this.options = JSON.parse(data.memberList);
                this.select_user = data.memberSelect;
                this.autoCheck = '';

                // console.log(this.options);
                //console.log(this.select_user);
            }

            this.select_medical_cd = data.selectData.MEDICAL_CODE;
            this.dc_memo = data.selectData.DC_MEMO;
            if (data.selectData.DC == '' || data.selectData.DC == 'N') {
                this.dc = false;
            } else {
                this.dc = true;
            }

            this.select_date = data.selectData.YMD_STRING.substring(0, 4) + '-' + data.selectData.YMD_STRING.substring(4, 6) + '-' + data.selectData.YMD_STRING.substring(6, 8);

            this.select_time = data.selectData.REAL_TIME_STRING;
            this.awaitTimeChk = data.selectData.AWAIT_TIME == '' ? false : true;
            this.awaitTime = data.selectData.AWAIT_TIME;
            this.prevDoctorSchedule = data.selectData;
            //console.log(this.prevDoctorSchedule);
        },

        async calendarSave() {
            let errorMsg = '';
            let week_sum = 0;
            if (this.select_date == '--') {
                this.select_date = '';
            }
            if (this.select_medical_cd == '') {
                errorMsg = '원장님을 선택하여 주십시오.';
            } else if (this.select_date == '') {
                errorMsg = '날짜를 선택해주세요.';
            } else if (this.select_time == '') {
                errorMsg = '시간을 입력해주세요.';
            } else if (this.select_gubun == '') {
                errorMsg = '등록 구분을 선택하여 주십시오.';
            } else if ((this.select_gubun == '1' || this.select_gubun == '2' || this.select_gubun == '3' || this.select_gubun == '4' || this.select_gubun == '5' ||this.select_gubun == '6' || this.select_gubun == '98') && this.select_user == '') {
                errorMsg = '환자를 선택하여 주십시오.';
            } else if (this.select_gubun == '99' && this.memo == '') {
                errorMsg = '메모를 입력하여 주십시오.';
            }
            
            if (this.autoCheck == 'true') {
                if (this.schedule_gubun_number == false) {
                    errorMsg = '주기를 입력해주세요.';
                }

                if (this.schedule_gubun_type == false) {
                    errorMsg = '주기옵션을 선택해주세요.';
                }

                if (this.schedule_gubun_type == 2) {
                    if (this.schedule_week.length == 0) {
                        errorMsg = '요일을 선택해주세요.';
                    } else {
                        for (let i = 0; i < this.schedule_week.length; i++) {
                            week_sum = parseInt(week_sum) + parseInt(this.schedule_week[i]);
                        }
                    }
                } else if (this.schedule_gubun_type == 3) {
                    if (this.schedule_gubun_days == 0) {
                        errorMsg = '매월(일)주기를 선택해주세요.';
                    }
                }

                if (this.schdule_endYN == 'Y') {
                    if (this.schedule_end == false) {
                        errorMsg = '종료날짜를 선택해주세요.';
                    }
                }
            }
            let select_time = document.getElementById('select_time').value;
            
            if (isNaN(select_time) == false) {
                this.select_time = select_time;
            }

            if (errorMsg != '') {
                this.$vs.notify({
                    title: 'Error',
                    text: errorMsg,
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            let dcString = '';
            if (this.dc == false) {
                dcString = 'N';
            } else {
                dcString = 'Y';
            }
            const jsonData = {
                select_medical_cd: this.select_medical_cd,
                select_date: this.customFormatter(this.select_date),
                select_time: this.select_time,
                memo: this.memo,
                memo_etc: this.memo_etc,
                select_gubun: this.select_gubun,
                select_user: this.select_user ? this.select_user.id : null,
                tab_medical_cd: this.medical_cd,
                schedule_seq: this.schedule_seq,
                dc: dcString,
                dc_memo: this.dc_memo,

                authCheck: this.autoCheck || null,
                schdule_endYN: this.schdule_endYN || 'N',
                schedule_end: this.schedule_end != '' ? this.customFormatter(this.schedule_end) : '',
                schedule_week: week_sum || 0,
                schedule_gubun_number: this.schedule_gubun_number || 1,
                schedule_gubun_type: this.schedule_gubun_type || 0,
                schedule_gubun_days: this.schedule_gubun_days || 0,
                awaitTime : this.awaitTime + '',
            };
            // console.log(jsonData);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            console.log(jsonData);

            const { data } = await axiosClass.post('/api/doctor/save', jsonData, true);

            if(this.customFormatter(this.now_date) == this.select_date && (this.select_gubun != '99' && this.select_gubun != '97')) {
                try {
                    if(this.prevDoctorSchedule == null) {
                        await this.sendKakaoWorkBot('add');
                        this.prevDoctorSchedule = null;
                    } else {
                        await this.sendKakaoWorkBot('modify');
                        this.prevDoctorSchedule = null;
                    }
                } catch (e) {
                    console.error('[sendKakaoWorkBot] 카카오워크 전송 실패 (저장은 완료):', e.message);
                }
            }

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            this.tabClick(this.select_medical_cd)
        },
        async calendarTdClick(item, schedule_item) {
            this.select_time = item.CODE_TIME;
            this.select_date = this.customFormatter(schedule_item);
            this.select_medical_cd = this.medical_cd;
            this.select_gubun = '';
            this.select_user = '';
            this.memo = '';
            this.popupOpen();
        },

        async clipCopy(item) {
            const div = document.getElementsByClassName('con-vs-chip');
            for (let i = 0; i < div.length; i++) {
                div[i].classList.remove('selectOn');
            }

            this.copy_schedule_seq = -1;
            if (
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.contains('selectOn')
            ) {
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.remove('selectOn');
            } else {
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.add('selectOn');
            }

            this.copy_schedule_seq = item.schedule_seq;
        },

        async clipCopyConfirm(ymd, time) {
            this.copy_select_date = ymd;
            this.copy_select_time = time;

            if (this.copyChecked.length == 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 컨텐츠를 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '복사',
                text: '선택한 예약을 복사하시겠습니까?',
                acceptText: '복사',
                cancelText: '취소',
                accept: this.DataCopy,
                cancel: function () {
                    return;
                },
            });
            // document.getElementsByClassName('con-vs-chip').classList.remove('selectOn');
        },

        async DataCopy() {
            const jsonData = {
                copy_date: this.copyChecked,
                ymd: this.copy_select_date,
                time: this.copy_select_time,
            };

            const { data } = await axiosClass.post('/api/doctor/copyV2', jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;

            this.date_list = data.cure_data[0].YMD.split(',');
            this.cure_data = data.cure_data;
            this.copyChecked = [];
            this.date_list = data.cure_data[0].YMD.split(',');
            this.cure_data = data.cure_data;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            const div = document.getElementsByClassName('con-vs-chip');
            for (let i = 0; i < div.length; i++) {
                div[i].classList.remove('selectOn');
            }
            this.copy_schedule_seq = -1;
            this.tabClick(this.medical_cd)
        },

        async calendarTdDelete(item) {
            this.select_schedule_seq = item.schedule_seq;
            this.popupActive = false;
            let _this = this;

            const { data } = await axiosClass.get('/api/doctor/schedule/' + item.schedule_seq, {}, true);
            console.log(data);
            this.prevDoctorSchedule = data.selectData;

            _this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택한 원장님 스케줄을 개별 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: _this.calendarDelete,
            });
        },

        async calendarDelete() {
            if (this.now_date == '') {
                this.now_date = dateClass.dateYYYYMM();
            }
            const jsonData = {
                select_date: this.now_date,
                tab_medical_cd: this.medical_cd,
            };
            const { data } = await axiosClass.delete('/api/doctor/deleteV2/' + this.select_schedule_seq, jsonData, true);

            this.sendKakaoWorkBot('delete');

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;

            this.date_list = data.cure_data[0].YMD.split(',');
            this.cure_data = data.cure_data;

            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 개별 삭제되었습니다.',
                color: 'danger',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            this.tabClick(this.medical_cd)
        },
        async curePlan(schedule_seq) {
            const { data } = await axiosClass.post('/api/cure/select/' + schedule_seq, {}, true);

            if (data.cure_plan['PLAN'] == '') {
                data.cure_plan['PLAN'] = '없음';
            }
            this.popupActive = false;
            let _this = this;
            _this.$vs.dialog({
                color: 'primary',
                title: data.cure_plan['PATIENT_USERNAME'] + '님 치료플랜',
                text: data.cure_plan['PLAN'],
                acceptText: '닫기',
            });
        },
        async popupOpen(day, time) {
            this.schedule_seq = -1;
            this.select_date = day.substring(0, 4) + '-' + day.substring(4, 6) + '-' + day.substring(6, 8);
            this.awaitTimeChk = false;
            this.awaitTime = '';
            this.select_time = time;
            const { data } = await axiosClass.get('/api/cure/select', {}, true);
            this.select_medical_cd = this.medical_cd;
            this.select_user = '';
            this.memo = '';
            this.select_gubun = '';
            this.dc = false;
            this.dc_memo = '';
            this.time_list = data.timeList;
            this.memo_etc = '';
            // 반복설정 상태 초기화
            this.autoCheck = null;
            this.schdule_endYN = 'N';
            this.schedule_end = '';
            this.schedule_week = [];
            this.schedule_gubun_type = 0;
            this.schedule_gubun_number = 1;
            this.schedule_gubun_days = 0;
            this.popupActive = true;
            this.options = [];
            // this.options = JSON.parse(data.memberList);
            // for (let i = 0; i < data.memberList.length; i++) {
            //     this.options.push({
            //         id: data.memberList[i].PATIENT_UID,
            //         label: data.memberList[i].MEDICAL_ROOM_NM + '-' + data.memberList[i].MEDICAL_ROOM_NUMBER_NM + ':' + data.memberList[i].PATIENT_USERNAME,
            //     });
            // }
            this.prevDoctorSchedule = null;
        },

        async clip() { },

        async memberReport(uid) {
            const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);

            this.popupActive2 = true;
            this.patientUsername = data.patientData.PATIENT_USERNAME;
            this.patientAge = data.patientData.PATIENT_AGE;
            this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
            this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
            this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
            this.medicalName = data.patientData.MEDICAL_NAME;
            this.sickNess = data.patientData.SICKNESS;
            this.plan = data.patientData.PLAN;
            this.memo = data.patientData.MEMO;
            this.chart_no = data.patientData.CHART_NO;
            this.status_name = data.patientData.STATUS_NAME;
            this.patient_phone = data.patientData.PATIENT_PHONE;
            this.in_init_date = data.patientData.IN_INIT_DATE;
            this.in_date = data.patientData.IN_DATE;
            this.out_date = data.patientData.OUT_DATE;
            this.complate_yn = data.patientData.COMPLATE_YN;
            this.meal_name = data.patientData.MEAL_NAME;
            this.medical_nm = data.patientData.MEDICAL_NM;
            this.west_medical_nm = data.patientData.WEST_MEDICAL_NAME;
            this.protector_phone = data.patientData.PROTECTOR_PHONE;
        },

        popupClose() {
            this.popupActive = false;
        },

        dayReturn(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item.substring(0, 4) + '-' + item.substring(4, 6) + '-' + item.substring(6, 8)).getDay()];
            return parseInt(item.substring(4, 6)) + '월 / ' + parseInt(item.substring(6, 8)) + '일(' + weekString + ')';
        },

        // gridReturn 메소드 수정본
        // gridReturnCurrentDate(time_index, day_index) {
        //     const currentDate = moment().format("YYYYMMDD");
        //     const data = this.cure_data[time_index];
        //     const schedule_seq = data.SCHEDULE_SEQ.split('///');
        //     const medical_nm = data.MEDICAL_NM2.split('///');
        //     const patient_username = data.PATIENT_USERNAME.split('///');
        //     const patient_uid = data.PATIENT_UID.split('///');
        //     const medical_room_nm = data.MEDICAL_ROOM_NM.split('///');
        //     const medical_room_number_nm = data.MEDICAL_ROOM_NUMBER_NM.split('///');
        //     const memo = data.MEMO.split('///');
        //     const memo_etc = data.MEMO_ETC.split('///');
        //     const reservation_time = data.REAL_TIME_STRING.split('///');
        //     const dc = data.DC.split('///');
        //     const dc_memo = data.DC_MEMO.split('///');
        //     const insert_gubun = data.INSERT_GUBUN.split('///');
        //     const medical_member_username = data.MEDICAL_MEMBER_USERNAME.split('///');
        //     const west_medical_username = data.WEST_MEDICAL_USERNAME.split('///');
        //     const repeat_seq = data.REPEAT_SEQ.split('///');
        //     const schedule_seq_temp = schedule_seq[day_index].split('|');
        //     const medical_nm_temp = medical_nm[day_index].split('|');
        //     const patient_username_temp = patient_username[day_index].split('|');
        //     const patient_uid_temp = patient_uid[day_index].split('|');
        //     const medical_room_nm_temp = medical_room_nm[day_index].split('|');
        //     const medical_room_number_nm_temp = medical_room_number_nm[day_index].split('|');
        //     const memo_temp = memo[day_index].split('|');
        //     const memo_etc_temp = memo_etc[day_index].split('|');
        //     const reservation_time_temp = reservation_time[day_index].split('|');
        //     const dc_temp = dc[day_index].split('|');
        //     const dc_memo_temp = dc_memo[day_index].split('|');
        //     const insert_gubun_temp = insert_gubun[day_index].split('|');
        //     const medical_member_username_temp = medical_member_username[day_index].split('|');
        //     const west_medical_username_temp = west_medical_username[day_index].split('|');
        //     const repeat_seq_temp = repeat_seq[day_index].split('|');
        //     const dayArr = [];

        //     for (let i = 0; i < schedule_seq_temp.length; i++) {
        //         let gubun_txt = '';
        //         if (insert_gubun_temp[i] == 1) {
        //             gubun_txt = '초진';
        //         } else if (insert_gubun_temp[i] == 2) {
        //             gubun_txt = '재진';
        //         } else if (insert_gubun_temp[i] == 3) {
        //             gubun_txt = '신입진료';
        //         } else if (insert_gubun_temp[i] == 4) {
        //             gubun_txt = '재입진료';
        //         } else if (insert_gubun_temp[i] == 5) {
        //             gubun_txt = '입원중진료';
        //         } else if (insert_gubun_temp[i] == 97) {
        //             gubun_txt = '휴진';
        //         } else if (insert_gubun_temp[i] == 98) {
        //             gubun_txt = '외래';
        //         } else if (insert_gubun_temp[i] == 99) {
        //             gubun_txt = '기타';
        //         }
        //         if (schedule_seq_temp[i] != false && reservation_time_temp[i].substring(0, 8) === currentDate) {
        //             const dayData = {
        //                 schedule_seq: schedule_seq_temp[i],
        //                 medical_nm: medical_nm_temp[i],
        //                 patient_username: patient_username_temp[i],
        //                 patient_uid: patient_uid_temp[i],
        //                 medical_room_nm: medical_room_nm_temp[i],
        //                 medical_room_number_nm: medical_room_number_nm_temp[i],
        //                 reservation_time: reservation_time_temp[i],
        //                 memo: memo_temp[i],
        //                 memo_etc: memo_etc_temp[i],
        //                 dc: dc_temp[i],
        //                 dc_memo: dc_memo_temp[i],
        //                 insert_gubun: insert_gubun_temp[i],
        //                 gubun_txt: gubun_txt,
        //                 medical_member_username: medical_member_username_temp[i],
        //                 west_medical_username: west_medical_username_temp[i],
        //                 repeat_seq: repeat_seq_temp[i],
        //             };
        //             dayArr.push(dayData);
        //         }
        //     }
        //     return dayArr;
        // },

        gridReturn(time_index, day_index) {
            const data = this.cure_data[time_index];
            const schedule_seq = data.SCHEDULE_SEQ.split('///');
            const medical_nm = data.MEDICAL_NM2.split('///');
            const patient_username = data.PATIENT_USERNAME.split('///');
            const patient_uid = data.PATIENT_UID.split('///');
            const medical_room_nm = data.MEDICAL_ROOM_NM.split('///');
            const medical_room_number_nm = data.MEDICAL_ROOM_NUMBER_NM.split('///');
            const memo = data.MEMO.split('///');
            const memo_etc = data.MEMO_ETC.split('///');
            const chart_no = data.CHART_NO.split('///');
            const reservation_time = data.REAL_TIME_STRING.split('///');
            const dc = data.DC.split('///');
            const dc_memo = data.DC_MEMO.split('///');
            const insert_gubun = data.INSERT_GUBUN.split('///');
            const medical_member_username = data.MEDICAL_MEMBER_USERNAME.split('///');
            const west_medical_username = data.WEST_MEDICAL_USERNAME.split('///');
            const repeat_seq = data.REPEAT_SEQ.split('///');
            const awaitTimeTempArray = data.AWAIT_TIME.split('///');
            
            const schedule_seq_temp = schedule_seq[day_index].split('|');
            const medical_nm_temp = medical_nm[day_index].split('|');
            const patient_username_temp = patient_username[day_index].split('|');
            const patient_uid_temp = patient_uid[day_index].split('|');
            const medical_room_nm_temp = medical_room_nm[day_index].split('|');
            const medical_room_number_nm_temp = medical_room_number_nm[day_index].split('|');
            const memo_temp = memo[day_index].split('|');
            const memo_etc_temp = memo_etc[day_index].split('|');
            const reservation_time_temp = reservation_time[day_index].split('|');
            const chart_no_temp = chart_no[day_index].split('|');
            const dc_temp = dc[day_index].split('|');
            const dc_memo_temp = dc_memo[day_index].split('|');
            const insert_gubun_temp = insert_gubun[day_index].split('|');
            const medical_member_username_temp = medical_member_username[day_index].split('|');
            const west_medical_username_temp = west_medical_username[day_index].split('|');
            const repeat_seq_temp = repeat_seq[day_index].split('|');
            const awaitTimeTemp = awaitTimeTempArray[day_index].split('|');

            const dayArr = [];
            let btn_color = 'primary';
            for (let i = 0; i < schedule_seq_temp.length; i++) {
                if (medical_nm_temp[i] == '김지호') {
                    btn_color = 'bgClass1';
                } else if (medical_nm_temp[i] == '김대경') {
                    btn_color = 'bgClass2';
                } else if (medical_nm_temp[i].trim() == '구자일') {
                    btn_color = 'bgClass3';
                } else if (medical_nm_temp[i].trim() == '윤성훈') {
                    btn_color = 'bgClass4';
                } else if (medical_nm_temp[i].trim() == '진정헌') {
                    btn_color = 'bgClass5';
                } else if (medical_nm_temp[i].trim() == '김정권') {
                    btn_color = 'bgClass6';
                } else if (medical_nm_temp[i].trim() == '이대진') {
                    btn_color = 'bgClass7';
                } else if (medical_nm_temp[i].trim() == '신종훈') {
                    btn_color = 'bgClass8';
                } else if (medical_nm_temp[i].trim() == '한연수') {
                    btn_color = 'bgClass9';
                } else if (medical_nm_temp[i].trim() == '정윤진') {
                    btn_color = 'bgClass10';
                } else {
                    btn_color = 'bgClass11';
                }

                if (awaitTimeTemp[i].trim() != '') {
                    btn_color = 'bgClass00';
                }

                const gubun_txt_temp = [];
                if (insert_gubun_temp[i] == 1) {
                    gubun_txt_temp[i] = '초진';
                } else if (insert_gubun_temp[i] == 2) {
                    gubun_txt_temp[i] = '재진';
                } else if (insert_gubun_temp[i] == 3) {
                    gubun_txt_temp[i] = '신입진료';
                } else if (insert_gubun_temp[i] == 4) {
                    gubun_txt_temp[i] = '재입진료';
                } else if (insert_gubun_temp[i] == 5) {
                    gubun_txt_temp[i] = '입원중진료';
                } else if (insert_gubun_temp[i] == 6) {
                    gubun_txt_temp[i] = '퇴원진료';
                } else if (insert_gubun_temp[i] == 97) {
                    gubun_txt_temp[i] = '휴진';
                } else if (insert_gubun_temp[i] == 98) {
                    gubun_txt_temp[i] = '외래';
                } else if (insert_gubun_temp[i] == 99) {
                    gubun_txt_temp[i] = '기타';
                }
                if (schedule_seq_temp[i] != false) {
                    dayArr.push({
                        schedule_seq: schedule_seq_temp[i],
                        medical_nm: (awaitTimeTemp[i] != '' ? '대기' : medical_nm_temp[i]),
                        patient_username: patient_username_temp[i],
                        patient_uid: patient_uid_temp[i],
                        medical_room_nm: medical_room_nm_temp[i],
                        medical_room_number_nm: medical_room_number_nm_temp[i],
                        reservation_time: reservation_time_temp[i],
                        memo: memo_temp[i],
                        memo_etc: memo_etc_temp[i],
                        btn_color: btn_color,
                        dc: dc_temp[i],
                        dc_memo: dc_memo_temp[i],
                        insert_gubun: insert_gubun_temp[i],
                        gubun_txt: gubun_txt_temp[i],
                        medical_member_username: medical_member_username_temp[i],
                        west_medical_username: west_medical_username_temp[i],
                        repeat_seq: repeat_seq_temp[i],
                    });
                }
            }
            return dayArr;
        },

        prevMonth() {
            this.now_date = this.prev_date;
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.tabClick(this.medical_cd);
        },
        nextMonth() {
            this.now_date = this.next_date;
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.tabClick(this.medical_cd);
        },
      updateDate(day) {
        if (day) {
          this.now_date = day;
          this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
          this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
          this.tabClick(this.medical_cd);
        }
      },
        activeMenu(medical_code) {
            if (medical_code == this.medical_cd) {
                return 'activeMenu';
            } else {
                return '';
            }
        },

        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        autoEvent() {
            if (this.autoCheck != 'true') {
                this.schdule_endYN = 'N';
                this.schedule_end = '';
                this.schedule_week = [];
                this.schedule_gubun_type = 0;
                this.schedule_gubun_number = 1;
                this.schedule_gubun_days = 0;
            }
        },

        async deleteAllConfirm(schedule_seq) {
            this.selected_schedule_seq = schedule_seq;
            this.popupActive = false;
            let _this = this;
            _this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택하신 날짜 이후의 원장님 스케줄을 전체 삭제 하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: _this.deleteConfirmAllProcess,
            });
        },

        async deleteConfirmAllProcess() {
            if (this.now_date == '') {
                this.now_date = dateClass.dateYYYYMM();
            }

            const jsonData = {
                schedule_seq: this.selected_schedule_seq,
                select_date: this.now_date,
                tab_medical_cd: this.medical_cd,
            };
            const { data } = await axiosClass.delete('/api/doctor/all', jsonData, true);
            // console.log(data);

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
            this.popupActive = false;

            this.tab_menu = data.tab_menu;

            this.date_list = data.cure_data[0].YMD.split(',');
            this.cure_data = data.cure_data;
            this.cure_count = data.cure_count;
            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];
            this.doctor_cnt = data.doctor_cnt;
            this.selected_schedule_seq = 0;
            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 삭제되었습니다.',
                color: 'danger',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            this.init('');
        },
        // 2023-05-10 TH 추가
        // 당일 추가된 스케쥴에 대해 카카오워크 알림톡을 보내는 기능
        async sendKakaoWorkBot(doctorDistinguish) {
            let msgText ='';

            // 시간 정보 가공
            let timeHourString = this.select_time.substring(0,2);
            let timeMinutesString = this.select_time.substring(2,4);

            let timeFullString = timeHourString + '시' + timeMinutesString + "분 ";
            console.log('this.select_user.id는 '+ this.select_user.id);

            // 환자 ID 유효성 검사
            if (!this.select_user.id || this.select_user.id === 'undefined' || this.select_user.id === undefined) {
                console.warn('[doctor/List] select_user.id is undefined, skipping API call');
                this.$vs.notify({
                    color: 'danger',
                    title: '오류',
                    text: '환자 정보를 확인해주세요.',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            // 환자 정보
            const massData = await axiosClass.get('/api/patient/view/'+ this.select_user.id, {}, true);
            const patientData = massData.data.memberData;
            const cdStatusList = massData.data.statusList;

            // 병실정보
            let patientRoom = '';
            let patientBed = '';
            let patientRoomAndBed = '';

            if(patientData.CD_STATUS == '8') {
                patientRoomAndBed = '외래 '
            } else if (this.select_gubun == '98') {
                if (patientData.MEDICAL_ROOM_NUMBER_NM == null || patientData.MEDICAL_ROOM_NUMBER_NM == undefined || patientData.MEDICAL_ROOM_NUMBER_NM == '') {
                    patientRoom = '';
                } else {
                    patientRoom = patientData.MEDICAL_ROOM_NUMBER_NM
                }

                if (patientData.MEDICAL_ROOM_NUMBER_CNT == null || patientData.MEDICAL_ROOM_NUMBER_CNT == undefined || patientData.MEDICAL_ROOM_NUMBER_CNT == '') {
                    patientBed = '';
                } else {
                    patientBed = '-' + patientData.MEDICAL_ROOM_NUMBER_CNT + '호 ';
                }

                patientRoomAndBed = patientRoom + patientBed;
            }

            // 최종 결합
            this.getGubunIndex();

            if(doctorDistinguish == 'add'){
                msgText = timeFullString + patientRoomAndBed + '\n' + patientData.PATIENT_USERNAME + ' '
                + this.gubun_list[this.selectGubunIndex].TEXT +  '(이)가 등록되었습니다.';
            } else if (doctorDistinguish == 'modify') {
                let prevData = this.prevDoctorSchedule;
                let prevTimeString = prevData.REAL_TIME_STRING.substring(0,2) + '시' + prevData.REAL_TIME_STRING.substring(2,4) + '분 ';
                this.getGubunIndex(prevData.INSERT_GUBUN);

                msgText = prevTimeString + patientRoomAndBed + '\n' + patientData.PATIENT_USERNAME + ' '
                + this.gubun_list[this.prevGubunIndex].TEXT;
                msgText += `\n\n변경되었습니다\n\n`;
                msgText += timeFullString + patientRoomAndBed + '\n' + patientData.PATIENT_USERNAME + ' '
                + this.gubun_list[this.selectGubunIndex].TEXT;

            } else if (doctorDistinguish == 'delete') {

                let prevData = this.prevDoctorSchedule;
                let prevTimeString = prevData.REAL_TIME_STRING.substring(0,2) + '시' + prevData.REAL_TIME_STRING.substring(2,4) + '분 ';

                this.getGubunIndex(prevData.INSERT_GUBUN);

                msgText = prevTimeString + patientRoomAndBed + '\n' + patientData.PATIENT_USERNAME + ' '
                + this.gubun_list[this.prevGubunIndex].TEXT;
                msgText += ' 취소되었습니다.';
            }

            console.log(this.doctorconversationList[this.select_medical_cd]);
            let doctorConversationId = this.doctorconversationList[this.select_medical_cd];
            // doctorConversationId = 6226325; // 개발주임test
            let doctorScheduleData = {
                conversationId : doctorConversationId,
                msgText : msgText,
                fromWhere : 3 // 원장님스케쥴일때
            }

            console.log(doctorScheduleData);
            const response = await axiosClass.post('/api/kakaoWork/sendMessages', doctorScheduleData, true);
            console.log(response);

        },

        // gubun index 구하는 메소드
        getGubunIndex (gubunValue) {
            let tempGubunList= ['1','2', '3', '4', '5', '6', '97', '98', '99'];
            if(gubunValue != null && gubunValue != undefined) {
                for(let i = 0; i < tempGubunList.length; i++) {
                    if(tempGubunList[i] == gubunValue) {
                        this.prevGubunIndex = i;
                    }
                }
                for(let i = 0; i < tempGubunList.length; i++) {
                    if(tempGubunList[i] == this.select_gubun) {
                        this.selectGubunIndex = i;
                    }
                }
            } else {
                for(let i = 0; i < tempGubunList.length; i++) {
                    if(tempGubunList[i] == this.select_gubun) {
                        this.selectGubunIndex = i;
                    }
                }
            }

        },
        setAwaitTime() {
            if(this.awaitTimeChk == true) {
                this.awaitTime = moment().format('YYYY-MM-DD HH:mm:ss');
            } else {
                this.awaitTime = '';
            }
            
        },
        async searchPatient (value) {
            this.options = [];
            console.log("aaaa")
            let params = {
                search_name : value
            }

            if(value != ''){
                const { data } = await axiosClass.get(
                    "/api/patient/search_patientList",
                    params,
                    true
                );
                for (let i = 0; i < data.data.length; i++) {
                    this.options.push({
                        id: data.data[i].PATIENT_UID,
                        patientPhone : data.data[i].PATIENT_PHONE,
                        patientName : data.data[i].PATIENT_USERNAME,
                        patientUid : data.data[i].PATIENT_UID,
                        oxygenPoint : data.data[i].OXYGEN_POINT || 0,
                        label: (data.data[i].MEDICAL_ROOM_NM != '' ? data.data[i].MEDICAL_ROOM_NM + '-' + data.data[i].MEDICAL_ROOM_NUMBER_NM + ' : ' : '') + data.data[i].CHART_NO + '/' + data.data[i].PATIENT_USERNAME + '('+ data.data[i].PATIENT_PHONE.substr(9,4) + ')',
                    });
                }
            }

        },
        resetOption () {
            this.options=[];
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize);
        await this.init('');
        await this.getState('');
        this.$nextTick(() => {
            const inputElement = this.$refs.searchInput.$el.querySelector("input");
            if (inputElement) {
            inputElement.addEventListener("keyup", (event) => {
                if (event.key === "Enter") {
                    console.log("111")
                this.searchPatient(inputElement.value);
                }
            });
            }
        });
    },

    computed: {
        nowDate() {
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        },
        // filteredDates() {
        //     const specificDoctor = this.medical_cd !== "";
        //     const currentDate = moment().format("YYYYMMDD");

        //     // 원장 탭일 경우 시작 날짜를 현재 날짜로 설정
        //     const startDate = specificDoctor ? currentDate : moment(this.now_date).startOf("day").format("YYYYMMDD");

        //     const endDate = specificDoctor
        //         ? moment(startDate)
        //             .add(2, "days")
        //             .startOf("day")
        //             .format("YYYYMMDD")
        //         : null;

        //     const result = dateClass.filteredDates(startDate, endDate, specificDoctor);

        //     return result;
        // },
        // visibleSchedules() {
        //     const selectedDates = this.filteredDates;

        //     const result = this.cure_data.map((item) => {
        //         const visibleDates = item.YMD.split(",").filter((date) => {
        //             return selectedDates.includes(date);
        //         });
        //         // 현재 날짜 이전의 스케줄 데이터를 제거
        //         const currentDate = moment().format("YYYYMMDD");
        //         const filteredVisibleDates = visibleDates.filter((date) => {
        //             return date >= currentDate;
        //         });
        //         return {
        //             ...item,
        //             YMD: filteredVisibleDates.join(","),
        //         };
        //     });

        //     return result;
        // },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
window.addEventListener('resize', reportWindowSize);
window.addEventListener('load', reportWindowSize);
function reportWindowSize() {
    document.getElementById('calendarDiv').style.height = document.documentElement.clientHeight - 500 + 'px';
}
</script>

<style>
.calendar tbody tr td {
    padding: 10px;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 0.9rem;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}

.days_right {
    width: 100%;
    text-align: right;
    flex-direction: row;
    padding-right: 5px;
}

table>thead>tr>th {
    font-weight: 400;
    background-color: blue;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    z-index: 1;
}

table>tbody>tr>td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.tb_box {
    height: 750px;
    overflow: auto;
}

.table_header {
    position: sticky;
    top: 0;
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}

.mx-datepicker-popup {
    z-index: 90000000 !important;
}

.centerx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.round-btn {
    border-radius: 8px;
    padding: 0.2rem;
    font-size: 0.4rem;
    border: 1px solid rgba(var(--vs-primary), 1);
    background: transparent !important;
    color: rgba(var(--vs-primary), 1);
    margin-top: 0.2rem;
}

.del-btn {
    border-radius: 8px;
    padding: 0.2rem;
    font-size: 0.4rem;
    border: 1px solid rgba(var(--vs-primary), 1);
    background: transparent !important;
    color: rgba(var(--vs-primary), 1);
    margin-top: 0.2rem;
}

html {
    scroll-behavior: smooth;
}

.contentTable {
    font-size: 12px;
}

.headerBtn {
    background-color: rgba(241, 241, 241, 0.9);
    padding: 5px 10px;
}

.headerBtn a {
    padding: 5px;
}

.timeHeader {
    position: sticky;
    left: 0;
    z-index: 999;
}

.bgClass1 {
    background-color: rgba(128, 175, 178, 0.3) !important;
}

.bgClass2 {
    background-color: rgba(150, 180, 214, 0.3) !important;
}

.bgClass3 {
    background-color: rgba(196, 164, 148, 0.3) !important;
}

.bgClass4 {
    background-color: rgba(201, 149, 164, 0.3) !important;
}

.bgClass5 {
    background-color: rgba(179, 167, 206, 0.3) !important;
}

.bgClass6 {
    background-color: rgba(239, 234, 185, 0.678) !important;
}

.bgClass7 {
    background-color: rgba(204, 216, 195, 0.3) !important;
}

.bgClass8 {
    background-color: rgba(224, 227, 154, 0.3) !important;
}

.bgClass9 {
    background-color: rgba(104, 227, 154, 0.3) !important;
}

.bgClass10 {
    background-color: rgba(146, 227, 146, 0.3) !important;
}

.bgClass11 {
    background-color: rgba(107, 164, 147, 0.3) !important;
}
.bgClass00 {
    background-color:rgba(102, 101, 101,0.3)
}
#statuscnt6Id {
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
}

.mx-table th {
  background-color: #fff;
}

.mx-datepicker {
  width: 10px;
}

#datepicker-component.mx-datepicker svg {
  color: green;
  margin-top: 3px;
}
#datepicker-component input {
  border: 0;
  outline: none;
  box-shadow: none;
}
</style>
